import { ActionType, ErrorTypes, LoadingStatusType } from 'interfaces';
import {
  action,
  createRequestTypes,
  FAILURE,
  REQUEST,
  RequestTypes,
  SUCCESS,
} from 'services/api';

export const CONTENT: RequestTypes = createRequestTypes('CONTENT');
export const SET_CONTENT_STATUS = 'SET_CONTENT_STATUS';
export const CATEGORY_CONTENTS: RequestTypes =
  createRequestTypes('CATEGORY_CONTENTS');
export const SET_CONTENT_CATEGORY_STATUS = 'SET_CONTENT_CATEGORY_STATUS';
export const INCREMENT_CONTENT_CATEGORY_PAGE =
  'INCREMENT_CONTENT_CATEGORY_PAGE';
export const RESET_CONTENT_CATEGORY = 'RESET_CONTENT_CATEGORY';

export const content = {
  request: ({ id }: { id: string | number }): ActionType =>
    action(CONTENT[REQUEST], { id }),
  success: ({
    id,
    content,
  }: {
    id: string | number;
    content: unknown;
  }): ActionType => action(CONTENT[SUCCESS], { id, content }),
  failure: ({
    id,
    error,
  }: {
    id: string | number;
    error: ErrorTypes;
  }): ActionType => action(CONTENT[FAILURE], { id, error }),
};

export const setContentStatus = (status: LoadingStatusType): ActionType =>
  action(SET_CONTENT_STATUS, { status });

export const categoryContents = {
  request: ({
    id,
    page = 1,
  }: {
    id: string | number;
    page?: number;
  }): ActionType => action(CATEGORY_CONTENTS[REQUEST], { id, page }),
  success: ({ categoryContents }: { categoryContents: unknown }): ActionType =>
    action(CATEGORY_CONTENTS[SUCCESS], { categoryContents }),
  failure: ({ error }: { error: ErrorTypes }): ActionType =>
    action(CATEGORY_CONTENTS[FAILURE], { error }),
};

export const setContentCategoryStatus = (
  status: LoadingStatusType,
): ActionType => action(SET_CONTENT_CATEGORY_STATUS, { status });

export const incrementContentCategoryPage = (): ActionType =>
  action(INCREMENT_CONTENT_CATEGORY_PAGE);

export const resetContentCategory = (): ActionType =>
  action(RESET_CONTENT_CATEGORY);
